export const slate = {
  meta: {
    name: 'Slate'
  },
  layout: {
    content: {
      border: {
        left: '0'
      },
      boxShadow: '0 0 4px rgba(0, 0, 0, .1)'
    }
  },
  sidebar: {
    background: {
      color: '#2f3e46'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 #2a3b42'
    },
    divider: {
      color: '#44555d'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',

      badge: {
        backgroundColor: '#44555d',
        color: 'var(--color-white)'
      }
    },

    section: {
      heading: {
        color: {
          _: '#6d7c86',
          hover: '#8fa1ad',
          active: 'var(--color-white)'
        },
        icon: {
          background: {
            color: {
              active: '#26363d'
            }
          },
          color: {
            _: '#6d7c86',
            active: 'var(--color-white)'
          }
        }
      },
      items: {
        border: {
          left: '2px solid #44555d'
        },
        active: {
          item: {
            color: '#6d7c86'
          }
        }
      },
      item: {
        backgroundColor: {
          active: '#26363d',
          hover: 'rgba(255,255,255,.03)'
        },
        color: {
          _: '#6d7c86',
          hover: '#8fa1ad',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: '#26363d'
      },
      name: {
        color: 'var(--color-white)'
      },
      company: {
        color: '#5a6f79'
      },
      trigger: {
        backgroundColor: '#36474f',
        color: 'var(--color-white)'
      }
    }
  }
};
